import { render, staticRenderFns } from "./VacunaTipoNino.vue?vue&type=template&id=70a90d6a&scoped=true"
import script from "./VacunaTipoNino.vue?vue&type=script&lang=js"
export * from "./VacunaTipoNino.vue?vue&type=script&lang=js"
import style0 from "./VacunaTipoNino.vue?vue&type=style&index=0&id=70a90d6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a90d6a",
  null
  
)

export default component.exports